import { intro, sfeer } from "../../data/content";

export const Intro = () => {
  return (
    <section data-testid="intro-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-4">
          <img
            src={sfeer.gevel}
            alt="Het gevelbord van De Proatkoele"
            className="rounded-2xl border border-white/10 shadow-2xl w-full object-cover"
          />
        </div>
        <div className="md:col-span-8">
          <span className="text-primary font-semibold text-sm uppercase tracking-wide">Welkom</span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight mt-3">
            {intro.kop}
          </h2>
          <div className="mt-5 space-y-5">
            {intro.tekst.map((p, i) => (
              <p key={i} className="text-lg text-muted-foreground leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
